export const fetch_design_templates = () => (dispatch) => {
    var url = global.config.server_path+'design/get';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


export const fetch_owned_designs = () => (dispatch) => {
    var url = global.config.server_path+'user/fetch_owned_designs';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


export const fetch_design_categories = () => (dispatch) => {
    var url = global.config.server_path+'category/get_design_categories';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}


export const copy_into_saved_design = (id) => (dispatch) => {
    var url = global.config.server_path+'design/copy_into_saved_design';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

export const create_blank_design = (width,height,dimension_units) => (dispatch) => {
    var url = global.config.server_path+'saved_design/create_blank_design';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({width:width,height:height,dimension_units:dimension_units})})
    .then(resp => resp.json())
    .then(resp => validate_response(resp))
    .then(resp => Promise.resolve(resp.data))
    .catch(err => Promise.reject(err))
}

export const move_design_to_folder = (folder_id, design_id) => {
    const url = global.config.server_path+'saved_design/move_to_folder';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({folder_id: folder_id, design_id : design_id})})
    .then(data => {
        return Promise.resolve('successfully moved to folder.')
    })
    .catch(err => Promise.reject(err))
};

export const delete_design = (design_id) => {
    const url = global.config.server_path+'saved_design/delete'
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({id: design_id})})
    .then(data => {
        return Promise.resolve('successfully deleted design.')
    })
    .catch(err => Promise.reject(err))
};


var validate_response = (response) => response.response_code === 1 ? Promise.resolve(response) : Promise.reject(response)